import { getFinanceMinOpenDate, isFinanceDateLocked } from "./financeLockHelper";

let cachedLockDay = null;

export const setGlobalPastMonthLockDay = (lockDay) => {
  cachedLockDay = lockDay;
};

export const getGlobalPastMonthLockDay = () => {
  return cachedLockDay;
};

export const getFiscalYearRange = (date, lockDay = cachedLockDay) => {
  const selectedDate = date ? new Date(date) : new Date();
  const year = selectedDate.getFullYear();
  let minDate, maxDate;
  if (selectedDate.getMonth() >= 6) { // 0-indexed: 6 is July
    minDate = new Date(year, 6, 1); // July 1st of current year
    maxDate = new Date(year + 1, 5, 30); // June 30th of next year
  } else {
    minDate = new Date(year - 1, 6, 1); // July 1st of previous year
    maxDate = new Date(year, 5, 30); // June 30th of current year
  }
  const today = new Date();
  if (maxDate > today) {
    maxDate = today;
  }

  // If past month lock day is configured, minDate should be at least getFinanceMinOpenDate(lockDay)
  const lockMinDate = getFinanceMinOpenDate(lockDay);
  if (lockMinDate && lockMinDate > minDate) {
    minDate = lockMinDate;
  }

  return { minDate, maxDate };
};

export const isPreviousFiscalYear = (date) => {
  if (!date) return false;
  const txRange = getFiscalYearRange(date);
  const today = new Date();
  return today < txRange.minDate || today > txRange.maxDate;
};

export const getMinMaxDates = (selectedDate, initialDate, lockDay = cachedLockDay) => {
  const activeDate = selectedDate || initialDate || new Date();
  return getFiscalYearRange(activeDate, lockDay);
};

export const validateTransactionDate = (selectedDate, initialDate, lockDay = cachedLockDay) => {
  if (isFinanceDateLocked(selectedDate, lockDay)) {
    return "Action forbidden: Financial entries for this period are locked by Markazi Nazim Maliyat.";
  }
  return null;
};
